@if (uploadQueueImplRef.popTypeDuringUpload == 'cancelAllUploads') {
  <app-cancel-all-uploads [showCancelAllUploads]="uploadQueueImplRef.popTypeDuringUpload == 'cancelAllUploads' && !uploadQueueImplRef.uploadCompleted" (confirmCancel)="confirmCancel($event)"/>
}
@if (uploadQueueImplRef.popTypeDuringUpload == 'folderNotSupported') {
  <app-folder-name-not-supported-for-upload [enableButton]="enableButton" [currentFolder]="uploadQueueImplRef.folderForUpload" [showFolderNotSupportedPopUp] = "uploadQueueImplRef.popTypeDuringUpload == 'folderNotSupported'" (renamedFolder)="startFolderUpload($event)" (createFolderValidation)="validateBeforeCreatingFolder($event)"/>
} 
@if (uploadQueueImplRef.popTypeDuringUpload == 'duplicateFolder') {<!--[currentFolder]="implRef.folderForUpload"-->
  <app-duplicate-folder-popup  [currentFolderIndex]="uploadQueueImplRef.processingIndex" (uploadFolder)="decisionTakenForDuplicateFolders($event)" (closePopUp)="noActionOnDuplicateFolderPopUp()"/>
}
<div>
  <input type="file" #fileUpload id="fileUpload" name="fileUpload" multiple="multiple" style="display:none;" title="Click here to add files" />

  <input type="file" #fileUploadAlubm id="fileUploadAlubm" name="fileUpload" multiple="multiple" accept=".3fr,.3gp,.arw,.avi,.cr2,.cr3,.crw,.dc2,.dcr,.dng,.erf,.heic,.hif,.jpeg,.k25,.kdc,.mdc,.mef,.mkv,.mos,.mov,.mrw,.mts,.nef,.nrw,.orf,.pef,.qtk,.raf,.raw,.rdc,.rw2,.sr2,.srf,.webp,.x3f,*.avif,image/bmp,image/gif,image/jpeg,image/png,image/tiff,image/webp,video/mp4,video/x-m4v,video/*" style="display:none;" title="Click here to add files" />

  <input type="file" #fileUploadMemory id="fileUploadMemory" name="fileUpload" multiple="multiple" accept=".heic,.jpeg,.webp,*.avif,image/bmp,image/gif,image/jpeg,image/png,image/tiff,image/webp" style="display:none;" title="Click here to add files" />
  
  <input type="file" #fileUploadPhotos id="fileUploadPhotos" name="fileUpload" multiple="multiple" accept=".heic,.jpeg,.webp,*.avif,image/bmp,image/gif,image/jpeg,image/png,image/tiff,image/webp" style="display:none;" title="Click here to add files" />

  <input type="file" #fileUploadVideos id="fileUploadVideos" name="fileUpload" multiple="multiple" accept=".3gp, .avi, .mdc,.mef,.mkv,.mos,.mov,.mrw,.mts, video/mp4,video/x-m4v,video/*" style="display:none;" title="Click here to add files" />

  <!-- <input type="file" #fileUploadAudios id="fileUploadAudios" name="fileUpload" multiple="multiple" accept=".wav, .mp3, .m4a, .Flac, .3gp, .wmv, .mid, .imelody, .ota, .rtx, .xmf, .aiff, .ogg, .m4r, .wma, .ts, audio/mp3, audio/*" style="display:none;" title="Click here to add files" /> -->

  <input type="file" #folderUpload id="folderUpload" name="fileUpload"  webkitdirectory directory style="display:none;" title="Click here to add files" />

  
  <div id="uploadContainer"  class="progress_container" [style.display]="uploadQueueImplRef.uploadStarted ? 'block': 'none'" [ngClass]="{'visiblityHidden': universalService.isProfilePicUpload || universalService.mobileSelectionModeOn}">
   
    <div class="progress_container_header pogressBarHeaderCont">

      <p>
        @if (uploadQueueImplRef.uploadQueue.length>0 && uploadQueueImplRef.isUploadOn()) {
          <span>
            &nbsp; Uploading
          </span>
        }
        @if (uploadQueueImplRef.uploadQueue.length>0 && uploadQueueImplRef.isUploadOn()) {
          <span>{{uploadQueueImplRef.uploadingCount()}}</span>
        }

        @if (uploadQueueImplRef.uploadQueue.length>0 && uploadQueueImplRef.isUploadOn() && uploadQueueImplRef.uploadingCount()==1) {
          <span> item </span>
        }
        @if (uploadQueueImplRef.uploadQueue.length>0 && uploadQueueImplRef.isUploadOn() && uploadQueueImplRef.uploadingCount()!=1) {
          <span> items </span>
        }

        @if (uploadQueueImplRef.uploadQueue.length>0 && !uploadQueueImplRef.isUploadOn()) {
          <span>
            &nbsp; Uploaded
          </span>
        }

        @if (uploadQueueImplRef.uploadQueue.length>0 && !uploadQueueImplRef.isUploadOn()) {
          <span>{{uploadQueueImplRef.uploadedCount()}}</span>
        }
        @if (uploadQueueImplRef.uploadQueue.length>0 && !uploadQueueImplRef.isUploadOn() && uploadQueueImplRef.uploadedCount()==1) {
          <span> item</span>
        }
        @if (uploadQueueImplRef.uploadQueue.length>0 && !uploadQueueImplRef.isUploadOn() && uploadQueueImplRef.uploadedCount()!=1) {
          <span> items</span>
        }
      </p>
      @if (uploadQueueImplRef.failedUploads.length>0) {
        <p>|  &nbsp; {{uploadQueueImplRef.failedUploads.length}}
          @if (uploadQueueImplRef.failedUploads.length==1) {
            <span>Upload</span>
          }
          @if (uploadQueueImplRef.failedUploads.length!=1) {
            <span>Uploads were</span>
            } cancelled
          </p>
        }

        <div class="progress_btn_container">
          <span class="NeueDropdown_Inactive hidden upload_generic_style" (click)='minimizeUploadProgressBar()' id="collapse_btn" ></span>
          <span class="NeueDropdown_Active upload_generic_style"  (click)='maxmizeUploadProgressBar()' id="expand_btn" ></span>
          @if (uploadQueueImplRef.uploadQueue.length>0  ) {
            <span class="NeueFile_Cancel upload_generic_style" id='closeProgress' (click)='resetUploadParams();closeUploadProgressBar()'></span>
          }
        </div>
        <div class="upload_progress_bar_container">
          <div id='overallProgressBar' class="quota_graph_bar "></div>
        </div>
      </div>

      <div class="progress_container_header borderUploadBtm" >
        <div style="float: left;" class="uploadCncelBtn upldTimeContainer" >
          @if (uploadQueueImplRef.uploadCompleted==false && uploadQueueImplRef.uploadQueue.length>=1) {
            <span style="color: black;padding: 0 8px;float: left;">{{uploadQueueImplRef.gettimeLeftToFinishUpload()}}</span>
          }
        </div>
        <div class="uploadCncelBtn">
          @if ((uploadQueueImplRef.uploadCompleted==false && uploadQueueImplRef.isRetryAll==true && uploadQueueImplRef.uploadQueue.length>1)||(!uploadQueueImplRef.uploadCompleted && uploadQueueImplRef.cancelAll && uploadQueueImplRef.uploadQueue.length>1) ) {
            <span class="progressOptText pointer" (click)='cancelAllUploads()'> Cancel
            </span>
          }
          @if (uploadQueueImplRef.uploadCompleted==true && uploadQueueImplRef.isRetryAll==true && uploadQueueImplRef.isAnyFileWaiting()==false && uploadQueueImplRef.uploadQueue.length>1 && uploadQueueImplRef.checkIfUploadQueueContainsOnlyFolders() == false) {
            <span class="progressOptText pointer" (click)="uploadQueueImplRef.retryAllUpload()" >
              Retry
            </span>
          }
          @if (uploadQueueImplRef.uploadCompleted==true && uploadQueueImplRef.isRetryAll==false && uploadQueueImplRef.isAnyFileWaiting()==false) {
            <span class="progressOptText pointer" >{{uploadQueueImplRef.uploadQueue.length-uploadQueueImplRef.failedUploads.length}}
              @if (uploadQueueImplRef.uploadQueue.length-uploadQueueImplRef.failedUploads.length<=1) {
                <span>upload</span>
              }
              @if (uploadQueueImplRef.uploadQueue.length-uploadQueueImplRef.failedUploads.length>1) {
                <span>uploads</span>
                } completed
                @if (uploadQueueImplRef.failedUploads.length>1) {
                  <span>and {{uploadQueueImplRef.failedUploads.length}} cancelled.</span>
                }
              </span>
            }
          </div>
        </div>

        <div id="progress_list" class="progress_list">
          @for (file of uploadQueueImplRef.uploadQueue; track file) {
            <div class="upload_file_progress" (mouseover)="populateHoveredFile(file)" (mouseleave)="removeSelectedFile(file)" [ngClass]="[file == showunderline && file.uploadDone && !file.alreadyExists ? 'highlight-selected-row' : '']">
              <div class="circleProgressContainer" >
                <div class="progressHover progress progress_{{file.index}}" [hidden]="(this.universalService.isMobileDevice && !file.uploadStarted) || file.uploadDone || file.alreadyExists || file.isError || file.preparingUpload"></div>
                <div class="d-none d-md-block " >
                  <div class="showCncelOnHover" [hidden]="file.uploadDone || file.alreadyExists || file.isError" (click)='cancelSingleUpload(file)'>
                    <span class="cancelUploadButton NeueFile_Cancel  cancelButtonMargin" ></span>
                  </div>
                </div>
              </div>
              @if (file.isFile) {
                <div class='fileStripOvrlay' >
                  <div class="clearfix bshadow0 pbs file_upload_progress_icon_container">
                    @if(file?.imageTranscodeUrl){
                      <img src="{{file?.imageTranscodeUrl}}" class="img-fluid img-thumbnail imageBox" loading="lazy" (error)="universalService.thumbnailError($event)">
                      @if(file.icon == "NeuePlayFilled"){
                        <span class="NeuePlayFilled imageTypeIcon"></span>
                      }@else if(file.icon == "NeueAudio"){
                        <span class="NeueAudio imageTypeIcon"></span>
                      }
                    }
                    <span class="table_sidebar_icon fileIconBox {{file.icon}}"></span>
                  </div>
                  <span class="file_upload_progress_file_name uploading-file-name" title="{{file.name}}" (click)="openPreviewOfFile(file)" [ngStyle]="{ 'text-decoration' : ((showunderline==file && file.uploadDone && !file.alreadyExists) || (file.uploadDone && !file.alreadyExists && universalService?.isMobileDevice))  ? 'underline' : 'none' ,'cursor' : (showunderline == file && file.uploadDone && !file.alreadyExists)  ? 'pointer' : '' }">{{file.name}}</span>
                  <span class='uploadFileSize progressOptText'> ({{file.size | bytesConversion }}  )</span>
                  <span class="progress_close_btn progressOptText pointer" [hidden]="!file.preparingUpload" >
                    <div class="loader" style="width: 25px; height: 25px;float: left;" title='Preparing'></div>
                  </span>
                  @if (file.isError && !file.alreadyExists) {
                    <span class="progress_close_btn progressOptText pointer uploadErrorBtnCont" [ngClass]="[file.albumNotSupproted ? 'pe-none' : '']" >
                      <span (click)="retrySingleUpload(file)" class="NeueError"></span>
                      @if (!file.albumNotSupproted) {
                        <span class="d-none d-md-block">
                          @if (file.isError && !file.alreadyExists) {
                            <span class="progress_close_btn progressOptText pointer uploadRestoreBtnCont" >
                              <span (click)="retrySingleUpload(file)" class="NeueRestore"></span>
                            </span>
                          }
                        </span>
                      }
                    </span>
                  }
                  @if (!file.albumNotSupproted) {
                    <span class="d-block d-md-none">
                      @if (file.isError && !file.alreadyExists) {
                        <span class="progress_close_btn progressOptText pointer uploadRestoreBtnCont" >
                          <span (click)="retrySingleUpload(file)" class="NeueRestore"></span>
                        </span>
                      }
                    </span>
                  }
                  <span class="d-block d-md-none">
                    <span class="cancelUploadButton NeueFile_Cancel  cancelButtonMargin" [hidden]="file.isError || file.uploadDone" (click)='cancelSingleUpload(file)'>
                    </span>
                  </span>
                  @if (file.uploadDone && !file.alreadyExists) {
                    <span class="progress_close_btn progressOptText uploadDoneIconCont">
                      <span class="NeueFile_Selected" [ngStyle]="{ 'display' : (showunderline==file && file.uploadDone && !file.alreadyExists) || (universalService?.isMobileDevice && file.uploadDone && !file.alreadyExists)  ? 'none' : 'block' ,'cursor' : (showunderline == file && file.uploadDone && !file.alreadyExists)  ? 'pointer' : '' }"></span>
                      <span class="progress_close_btn progressOptText pointer uploadLocationBtnCont" [ngStyle]="{ 'display' : (showunderline==file && file.uploadDone && !file.alreadyExists) || (universalService?.isMobileDevice && file.uploadDone && !file.alreadyExists)  ? 'block' : 'none' ,'cursor' : (showunderline == file && file.uploadDone && !file.alreadyExists)  ? 'pointer' : ''}">
                        <span title="Open File Location" class="NeueFolderFilled" (click)="openLocationOfFile(file)"></span>
                      </span>
                    </span>
                  }
                  @if (file.alreadyExists) {
                    <span class="progress_close_btn progressOptText">
                      Already Exists
                    </span>
                  }
                </div>
              }
             
              @if (!file.isFile) {
                <div class='fileStripOvrlay'>
                  <div class="clearfix bshadow0 pbs file_upload_progress_icon_container">
                    <span class="table_sidebar_icon  fileIconBox {{file.icon}}"></span>
                  </div>
                  <div class="folder_name_container">
                    <span class="file_upload_progress_file_name" title="{{file.newName}}">
                      <span class="open-folder" (click)="openFolder(file)" [ngStyle]="{ 'text-decoration' : ((showunderline==file && file.uploadDone && !file.alreadyExists) || (file.uploadDone && !file.alreadyExists && universalService?.isMobileDevice))  ? 'underline' : 'none' ,'cursor' : (showunderline == file && file.uploadDone && !file.alreadyExists)  ? 'pointer' : '' }">{{file.newName}}</span>
                      @if (file.errorMsg != 'Already exists.') {
                        <p title="({{file.uploadedFilesInFolder}} of {{file.filesCountInFolder}})">({{file.uploadedFilesInFolder}} of {{file.filesCountInFolder}})</p>
                      }
                    </span>
                  </div>
                  @if (file.errorMsg != 'Already exists.') {
                    <span class='uploadFileSize progressOptText floatL'>
                      {{file.uploadedFolderSize | bytesConversion}}/ {{file.droppedFolderSize | bytesConversion}}
                    </span>
                  }
                  <span class='uploadFileSize progressOptText floatR folderUploadCancelledCont' [hidden]= "!file.isError">
                    {{file.errorMsg}} &nbsp;&nbsp;&nbsp;
                    <span class="NeueError folderUploadErrorBtn"></span>
                  </span>
                  <span class="progress_close_btn progressOptText pointer floatR uploadDoneIconCont" [hidden]= "!file.uploadDone || file.isError" >
                    <span class="NeueFile_Selected" [ngStyle]="{ 'display' : (showunderline==file && file.uploadDone && !file.alreadyExists) || (universalService?.isMobileDevice && file.uploadDone && !file.alreadyExists)  ? 'none' : 'block' ,'cursor' : (showunderline == file && file.uploadDone && !file.alreadyExists)  ? 'pointer' : '' }"></span>
                    <span class="progress_close_btn progressOptText pointer uploadLocationBtnCont" [ngStyle]="{ 'display' : (showunderline==file && file.uploadDone && !file.alreadyExists) || (universalService?.isMobileDevice && file.uploadDone && !file.alreadyExists)  ? 'block' : 'none' ,'cursor' : (showunderline == file && file.uploadDone && !file.alreadyExists)  ? 'pointer' : ''}">
                      <span title="Open Folder Location" class="NeueFolderFilled" (click)="openLocationOfFile(file)"></span>
                    </span>
                  </span>
                  <div class="showCncelOnHover d-block d-md-none" (click)='cancelFolderUpload(file)'>
                    <span (click)="cancelFolderUpload(file)" class="NeueFile_Cancel  cancelUploadButton cancelButtonMargin" [hidden]="file.uploadStarted" ></span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
  </div> 
</div>